import { MenuItem, Select } from '@nextiva/next-ui-components';
import React from 'react';
import { Controller } from 'react-hook-form-new';
import { BRAND_REGISTRATION_FIELDS, MenuProps } from '../constants';
import { useGetStockExchanges } from '../WizardContextV3/useGetStockExchanges';

export function StockExchangeSelect({ control, disabled }) {
  const { data } = useGetStockExchanges();

  const stockExchanges =
    data?.stockExchanges?.map((stockExchange) => ({
      value: stockExchange,
      displayName: stockExchange,
    })) || [];

  return (
    <Controller
      control={control}
      name={BRAND_REGISTRATION_FIELDS.STOCK_EXCHANGE}
      rules={{ required: true }}
      render={({ field: { onChange, onBlur, value } }) => (
        <Select
          id="stock-exchange"
          data-testid="PlatformAdminUI-Messaging-BrandRegistration-StockExchageSelect"
          labelId="stock-exchange-label"
          fullWidth
          required
          placeholder="Select"
          onChange={onChange}
          disabled={disabled}
          onBlur={onBlur}
          value={value || ''}
          MenuProps={MenuProps}
        >
          {stockExchanges.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.displayName}
            </MenuItem>
          ))}
        </Select>
      )}
    />
  );
}
